import { useRef } from 'react';

import { Configuration, DefaultApi } from '@rtkwlf/eloc';

import { useAuthContext } from '@packages/legacy/auth';
import { env } from '@packages/utils/env';

export const useElocApi = (): DefaultApi => {
  const { fetchApi } = useAuthContext();

  const api = useRef(
    new DefaultApi(
      new Configuration({
        basePath: env.VITE_ELOC_BASE_PATH,
        fetchApi,
      }),
    ),
  );

  return api.current;
};
